export class mdlGetMobileNoRes{
    public RegNo:string;
    public MobileNo: string;
    public StatusCode: string;
    public StatusDescAr: string;
    public StatusDescEn: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlGetMobileNoRes.ts